// Settings › Communication › Calendar & meetings (owner: communication): calendar sync, logging meetings in
// activities and what uses the calendar; Meeting notes is the page's next tab.
import { createFileRoute } from '@tanstack/react-router';
import { CalendarSettingsPage } from '../../../features/comm-settings/CalendarSettingsPage';

export const Route = createFileRoute('/_settings/settings/calendar')({ component: CalendarSettingsPage });
